import React from 'react';
import TableCrud from '../../components/TableCrud';

const SupplierFormIndex = () => {
    const columns = [
        {
            label: "Descrição",
            name: "description"
        },
        {
            label: "Empresa",
            name: "tenant.name",
        },
        {
            label: "Ativo",
            name: "isActive"
        },
    ]

    return (
        <TableCrud title={"Laboratório"} table={"supplier"} columns={columns}/>
    );
}

export default SupplierFormIndex;
